import { reduzirFotoVeiculo, urlNaOrigem } from "./laudo-pdf-fotos-veiculo";
import { comPrazoPdf } from "./laudo-pdf-prazo";

type PecaComFoto = { id: string; nome: string; sequencia: number; fotoUrl?: string | null };

export class FotosPecasPdfError extends Error {
  constructor(message: string, cause?: unknown) {
    super(message, { cause });
    this.name = "FotosPecasPdfError";
  }
}

/** Foto ausente usa o placeholder. Foto cadastrada deve entrar inteira e decodificada no PDF. */
export async function carregarFotosPecasParaPdf(
  pecas: PecaComFoto[],
  { origemPermitida, timeoutMs = 30_000, reduzir = reduzirFotoVeiculo }:
    { origemPermitida: string; timeoutMs?: number; reduzir?: (blob: Blob) => Promise<string> },
): Promise<Record<string, string | null>> {
  const fotos: Record<string, string | null> = {};
  // Uma foto por vez: câmera de celular pode gerar dezenas de MB após decodificar.
  for (const peca of pecas) {
    fotos[peca.id] = null;
    if (!peca.fotoUrl) continue;
    try {
      if (!urlNaOrigem(peca.fotoUrl, origemPermitida)) throw new Error("ORIGEM_NAO_PERMITIDA");
      const response = await fetch(peca.fotoUrl, { signal: AbortSignal.timeout(timeoutMs) });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      // JPEG com extensão AMPF/MPO e WebP são decodificados pelo navegador e
      // reencodados em JPEG comum; o leitor do react-pdf não aceita todos esses contêineres.
      fotos[peca.id] = await comPrazoPdf(reduzir(await response.blob()), timeoutMs, "A decodificação da foto excedeu o tempo limite.");
    } catch (cause) {
      throw new FotosPecasPdfError(
        `Não foi possível carregar a foto da peça ${String(peca.sequencia).padStart(3, "0")} — ${peca.nome}. ` +
        "O PDF não foi enviado. Verifique a conexão e a foto cadastrada e tente novamente.", cause);
    }
  }
  return fotos;
}
